import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className='p-4 mt-4 footer'>
      <div className="row">
        <div className="col-3">
          <b>Tribunal de cuentas</b>
        </div>
        <div className="col-9 small">
          Dr. Luis Federico Leloir 309 - Neuquén - Tel. : (0299) 4495073 <br />
          {year} - Desarrollado por Departamento Tecnologías de Información - Tribunal de Cuentas
        </div>
      </div>
    </div>
  );
};

export default Footer;